// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=a09b3d5b-90ec-4a1a-8113-00017c0a6edc";
};